import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

const DORK_ANIMATION = [
  '<[o_o]>',
  '>[-_-]<',
  '<[0_0]>',
  '>[-_-]<',
  '<[·_·]>',
  '>[-_-]<',
];

/** Animated Dork face shown while the AI is thinking. */
export function DorkThinking({ className }: { className?: string }) {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFrame((f) => (f + 1) % DORK_ANIMATION.length);
    }, 140);
    return () => clearInterval(interval);
  }, []);

  return (
    <pre
      className={cn(
        'font-mono text-[#5a5a5a] leading-none tracking-tight select-none',
        className,
      )}
      aria-label="Thinking"
      aria-live="polite"
    >
      {DORK_ANIMATION[frame]}
    </pre>
  );
}
